import React, { useContext } from 'react';

import { Context } from '../MunicipalNoticeBoard';

import { Carousel } from './Carousel';
import { sortCategory } from '../utils/helpers';
import LoadingSpinner from '../utils/LoadingSpinner';

const Library = () => {
    const { mainFolder, rows, cols, hideEmptyPlaylistSwitch, font } = useContext(Context);

    const folders = mainFolder?.children.filter((f) => !hideEmptyPlaylistSwitch || f.countDocuments).sort(sortCategory);

    if (!folders?.length) {
        return <LoadingSpinner></LoadingSpinner>;
    }

    return (
        <Carousel cols={cols || 4} rows={rows || 2} gap={18} categories={folders} font={font}>
            {/*folders.children.map((folder) => {
                const iconId = folder.items.find((item) => iconNames.includes(item.name))?._id || null;
                const iconPath = folderIcons?.find((icon: any) => icon._id === iconId)?.data || null;

                const mainCategory = new Category(folder._id, folder.name, iconPath);

                return <CarouselItem key={folder._id}>{mainCategory.createMain(viewMainCategory)}</CarouselItem>;
            })*/}
        </Carousel>
    );
};

export default Library;
